import './Search.scss';
import Filters from '../filters/Filters';
import Draws from '../draws/Draws';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import axios from 'axios';

const Search = (props) => {
  const searchResults = useSelector((state) => state.search.results);

  useEffect(() => {
    if (searchResults.length > 0) {
      document.querySelector('.Draws').scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [searchResults]);

  return (
    <div className="Search">
      <Filters></Filters>
      <Draws data={searchResults}></Draws>
      <button onClick={() => {
        // axios.get('http://localhost/ariadne/update-database').then((response) => {
        axios.get('https://ariadne.page/update-database').then((response) => {
          alert('Το σύστημα ενημερώθηκε');
          window.location.reload();
        });
      }} style={{position: 'fixed', bottom: '10px', right: '10px'}}>Ενημέρωση</button>
    </div>
  );
};

export default Search;
